import { render, staticRenderFns } from "./FormPost3D.vue?vue&type=template&id=400ae08c&"
import script from "./FormPost3D.vue?vue&type=script&lang=js&"
export * from "./FormPost3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports